// extracted by mini-css-extract-plugin
export default {"title":"h_-z","warning":"i_-z","sizeOptionsLegendText":"j_-z"};